import { Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow } from "@/components/atoms/Table";

export const TableDetailRow = ({
    details,
    instrumentsTypes,
    totalColumns,
}: {
    details: {
        id: string;
        flowDate: Date;
        value: number;
        instrument: { mnemonic: string, instrumentType: string };
    }[];
    instrumentsTypes: { id: string; name: string }[];
    totalColumns: number;
}) => {
    return (
        <TableRow>
            <TableCell colSpan={totalColumns} className="p-0">
                <div className="p-4 bg-[--secondary-200] dark:bg-gray-800">
                    <Table className="w-full">
                        <TableHead>
                            <TableRow className="border-t border-gray-500">
                                <TableHeaderCell className="text-left text-black dark:text-white">Fecha</TableHeaderCell>
                                <TableHeaderCell className="text-left text-black dark:text-white">Nemotécnico</TableHeaderCell>
                                <TableHeaderCell className="text-left text-black dark:text-white">Tipo de Instrumento</TableHeaderCell>
                                <TableHeaderCell className="text-right text-black dark:text-white">Valor</TableHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {details.map((ff) => {
                                const instrumentType =
                                    instrumentsTypes.find((it) => it.id === ff.instrument.instrumentType)?.name ?? "-";
                                return (
                                    <TableRow
                                        key={ff.id}
                                        className="border-t border-gray-500 hover:bg-primary-500 hover:text-white"
                                    >
                                        <TableCell className="py-1">
                                            {new Date(ff.flowDate).toLocaleDateString("es-ES")}
                                        </TableCell>
                                        <TableCell className="py-1">{ff.instrument.mnemonic}</TableCell>
                                        <TableCell className="py-1">{instrumentType}</TableCell>
                                        <TableCell className="py-1 text-right">
                                            {ff.value.toLocaleString("es-CO", {
                                                style: "currency",
                                                currency: "COP",
                                            })}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            </TableCell>
        </TableRow>
    );
};
